import { Component, Input } from '@angular/core';
import { BuyProductService } from 'src/app/features/buy-product/buy-product.service';
import { ResponsiveService } from '@prlw/libs/responsive/responsive.service';
import { BuyProductContainer } from 'src/app/features/buy-product/buy-product.container';
import { MobileOverlayService } from '@prlw/libs/mobile-overlay/mobile-overlay.service';
import { Instrument } from '@prlw/core/monitor/instrument.entity';

@Component({
  selector: 'prlw-order-buy-button-ui',
  templateUrl: './order-buy-button.component.html',
  styleUrls: ['./order-buy-button.component.scss'],
})
export default class OrderBuyButtonComponent {
  @Input() instrument: Instrument | null = null;

  constructor(
    private buyProductService: BuyProductService,
    private responsiveService: ResponsiveService,
    private mobileOverlayService: MobileOverlayService,
  ) {}

  xsmall$ = this.responsiveService.xsmall$;

  showOverlay() {
    if (!this.instrument) return;
    if (this.xsmall$.getValue()) {
      this.mobileOverlayService.show(BuyProductContainer, {
        instrument: this.instrument,
      });
      return;
    }
    this.buyProductService.open(this.instrument);
  }
}
